<head>
<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <a-card title="Cadastro Vínculo Departamento">
    <form ref="form" @submit.prevent="submitForm">
      <div class="row">
        <div class="col-md-8">
          <label for="nome">Departamento</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <div class="input-group input-focus">
            <a-auto-complete v-model:value="registro.departamento.nome" style="width: 200px" @search="pesquisarDepartamentos" class="form-control border-left-0">
              <template v-slot:dataSource>
                <a-select-option v-for="item in departamentos" :key="item.nome" @click="onSelect(item, 'DEPARTAMENTO')">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>Médicos</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>
          <br />
          <div class="input-group input-focus">
            <a-auto-complete v-model:value="selecionarMedico.nome" style="width: 200px" @search="pesquisarMedicos" class="form-control border-left-0">
              <template v-slot:dataSource>
                <a-select-option v-for="item in medicosFiltro" :key="item.nome" @click="onSelect(item, 'MEDICO')">
                  {{ item.nome }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </div>
        </div>
        <div class="col-md-4">
          <label></label>
          <br />
          <button type="button" class="btn btn-primary" @click="selecionarItem">Incluir</button>
        </div>
      </div>

      <br />
      <div class="row" v-show="itensSelecionados.length > 0">
        <div class="col-md-8">
          <a-table :dataSource="itensSelecionados" :columns="columns">
            <template #action="{ record }">
              <a title="Opções" @click="removerItem(record)"><i class="fas fa-trash icon-trash"></i></a>
              &nbsp;
            </template>
          </a-table>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label for="status">Status</label><label style="margin-left: 1px; font-weight: bold; color: red">*</label>

          <div class="input-group input-focus">
            <select v-model="registro.situacao" class="ant-input ant-input-lg" style="margin: 0; height: 40px" required>
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <a-divider type="horizontal" />
      <div class="spaced-container">
        <button type="submit" class="btn btn-primary" @click="cadastrar">Salvar</button>
        <button class="btn btn-warning" @click="voltar">Voltar</button>
      </div>
    </form>
  </a-card>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { create, getById } from '@/components/service/vinculoDepartamentoMedicoService';
import { getListaDepartamento } from '@/components/service/departamentoService';
import { getListaProfissionaisResumida } from '@/components/service/profissionalService';

export default {
  name: 'FormVinculoDepartamentoMedico',
  setup() {
    return {};
  },
  data() {
    return {
      departamentos: [],
      medicos: [],
      medicosFiltro: [],
      selecionarMedico: { id: null, nome: null },
      itensSelecionados: [],
      registro: { departamento: { id: null, nome: null } },
      columns: [
        {
          title: 'Nome Médico',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },

        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    async cadastrar() {
      //this.v$.$validate()
      if (!this.$refs.form.checkValidity()) {
        this.submitted = true;
        openNotification(typesNotification.warning, 'Informe os campos obrigatórios!');
      } else if (this.itensSelecionados.length === 0) {
        openNotification(typesNotification.warning, 'Você deve incluir pelo menos um médico para cadastrar o vinculo departamento médico!');
      } else if (this.registro.departamento === null) {
        openNotification(typesNotification.warning, 'Informe um departamento para realizar a inclusão!');
      } else {
        let registroPost = { ...this.registro };
        registroPost.medicos = this.itensSelecionados;
        await create(registroPost).then(() => {
          //let retorno = r.data;
          if (!this.registro.id) {
            openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          } else {
            openNotification(typesNotification.success, 'Dados alterados com sucesso.');
          }
          this.itensSelecionados = [];
          this.submitted = true;
          this.registro = { departamento: { id: null, nome: null } };
        });
      }
    },

    onSelect(value, nome) {
      switch (nome) {
        case 'DEPARTAMENTO':
          this.registro.departamento = { id: value.id, nome: value.nome };
          break;
        case 'MEDICO':
          this.selecionarMedico = { id: value.id, nome: value.nome };
          break;
      }
    },

    removerItem(record) {
      const index = this.itensSelecionados.indexOf(record);
      if (index > -1) {
        this.itensSelecionados.splice(index, 1);
      }
    },
    selecionarItem() {
      if (this.selecionarMedico.id !== null && this.selecionarMedico.id !== undefined) {
        let itemSelecionado = { ...this.selecionarMedico };
        let jaContem = this.itensSelecionados.filter(function (item) {
          return item.nome === itemSelecionado.nome;
        });
        if (jaContem.length > 0) {
          openNotification(typesNotification.warning, 'O médico ' + itemSelecionado.nome + ' já está na lista!');
        } else {
          this.itensSelecionados.push(this.selecionarMedico);
          this.selecionarMedico = { id: null, nome: null };
          this.medicosFiltro = [];
        }
      } else {
        openNotification(typesNotification.warning, 'Você deve selecionar um médico para adicionar na lista!');
      }
    },
    async pesquisarDepartamentos(value) {
      if (value.length >= 2) {
        let filtros = { situacao: 'ATIVO', nome: value };
        await getListaDepartamento(filtros).then((response) => {
          this.departamentos = response.data;
        });
      }
    },
    async pesquisarMedicos(value) {
      if (value.length >= 2) {
        this.medicosFiltro = this.medicos.filter((e) => e.nome.toUpperCase().includes(value.toUpperCase()));
      }
    },
    voltar() {
      this.$router.go(-1);
    },

    async carregarMedicos() {
      await getListaProfissionaisResumida().then((p) => {
        this.medicos = p.data;
      });
    },
    async carregar() {
      if (this.$route.query.id) {
        const idUrl = this.$route.query.id;
        const res = await getById(idUrl);
        this.registro = { ...res.data, id: idUrl };
        if (this.registro.medicos) {
          this.itensSelecionados = [...this.registro.medicos];
        }
      }
    },
  },
  async created() {
    this.carregar();
    this.carregarMedicos();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}

.spaced-container * {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
